import React from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';

const Facilitate = () => {
  return (
    <section className="!px-4 md:!px-10">
      <div className="max-w-custom mx-auto">
        <div className="flex flex-col">
          <div className="flex flex-col gap-y-44 md:gap-y-0 sm:flex-row  space-x-13 pt-14 md:pt-30">
            <div className="w-full md:w-1/2 justify-items-start  sm:justify-items-center md:justify-items-start lg:justify-items-start ">
              <div className="relative w-8/12 sm:w-6/12 xl:w-auto left-0 xxs:left-4">
                <img
                  src="/health/images/manPhone.jpg"
                  className="h-72 !w-full sm:h-60 md:w-36 tab:h-96 tab:w-64 2xl:w-72 2xl:h-[567px] left-0 xl:left-11 object-contain"
                  alt="man on phone"
                />
                <img
                  src="/health/images/womenPhone.jpg"
                  className=" left-20 top-44 sm:top-30 h-60 w-full tab:h-80 tab:w-64 absolute xl:w-72 md:left-32 md:top-44 2xl:left-64 lg:!top-40 xl:!top-64  2xl:h-[410px] 2xl:w-[373px] object-contain"
                  alt="woman on phone"
                />
              </div>
            </div>
            <div className=" md:w-1/2 flex flex-col items-start !ml-0 md:ml-2 sm:justify-center 2xl:px-10 ">
              <div className="uppercase text-sm font-medium leading-4 md:leading-4.5  w-full ml-0 font-halyard tracking-0.5px">
                What We Do
              </div>
              <div className="capitalize text-[26px] leading-7.5 sm:text-9.5 md:leading-10.5 lg:text-14 lg:leading-14 font-medium font-halyard text-primaryText py-3">
                We Facilitate Access to Healthcare Services in Zimbabwe
              </div>
              <div className="text-md leading-6.5 lg:text-[18px]  sm:leading-7 font-normal text-midGray font-dm-sans ">
                Through a vast network of healthcare professionals throughout
                the country, we facilitate access to healthcare all over the
                country.
              </div>
              <div className="flex space-x-7 pt-4">
                <Link to={'/register'}>
                  <Button title={'sign up'} />
                </Link>
                <Link to={'/login'}>
                  <Button title={'sign in'} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Facilitate;
